export default __webpack_public_path__ + "static/media/09d.17925a4e.svg";